export const Marquee = ({ dark = false }) => {
  const text = "100% ITALIANO — CERTIFICATO GLUTEN FREE — PRONTO IN 5 MINUTI — CHEF MICHEL — CONSEGNA IN TUTTA ITALIA — ";
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y py-5 ${dark ? "bg-[#243329] border-[#33463A]" : "bg-[#2E8A57] border-[#247045]"}`}
    >
      <div className="marquee-track">
        {[0, 1].map((k) => (
          <span
            key={k}
            className="font-serif-display italic text-2xl sm:text-3xl whitespace-nowrap pr-4 text-[#FDFBF7]/90 tracking-wide"
          >
            {text}
          </span>
        ))}
      </div>
    </div>
  );
};
